import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f1090e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PersonInformation" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 PersonInformation__problems"
}
const _hoisted_3 = { class: "problems__header" }
const _hoisted_4 = { class: "flex items-center text-red-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-lg" }, null, -1))
const _hoisted_6 = { class: "font-semibold text-red-400 ml-3" }
const _hoisted_7 = { class: "problems__body" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = {
  key: 1,
  class: "PersonInformation__header"
}
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "font-semibold text-sm" }
const _hoisted_14 = {
  key: 2,
  class: "PersonInformation__body"
}
const _hoisted_15 = { class: "body__row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Имя", -1))
const _hoisted_17 = { class: "row__value" }
const _hoisted_18 = { class: "body__row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Фамилия", -1))
const _hoisted_20 = { class: "row__value" }
const _hoisted_21 = { class: "body__row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Отчество", -1))
const _hoisted_23 = { class: "row__value" }
const _hoisted_24 = { class: "body__row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Возраст", -1))
const _hoisted_26 = { class: "row__value" }
const _hoisted_27 = { class: "body__row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пол", -1))
const _hoisted_29 = { class: "row__value" }
const _hoisted_30 = { class: "flex items-center justify-end mt-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.person && _ctx.isRenderProblems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, "Имеются проблемы (" + _toDisplayString(_ctx.courtCaseProblems.length + _ctx.reliabilityFlProblems.length) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.courtCaseProblems.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_8, " Сведения по судебным разбирательствам (" + _toDisplayString(_ctx.courtCaseProblems.length) + ") ", 1),
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courtCaseProblems, (court_case_problem, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `CourtCaseProblem-${i}`
                      }, _toDisplayString(court_case_problem), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.reliabilityFlProblems.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_10, " Благонадежность (" + _toDisplayString(_ctx.reliabilityFlProblems.length) + ") ", 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reliabilityFlProblems, (reliabilityfl_problem, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `ReliabilityFlProblem-${i}`
                      }, _toDisplayString(reliabilityfl_problem), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.person)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.person.name), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.person.iin), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.person)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.person.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.person.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.person.patronymic), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.person.age), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.person.gender), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_the_button, {
        class: "red small mr-6",
        loading: _ctx.isDeclineLoading,
        disabled: !_ctx.isCanDecline || _ctx.isConfirmLoading,
        onClick: _ctx.onDecline
      }, {
        default: _withCtx(() => [
          _hoisted_31,
          _createTextVNode(" Отказать ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.isConfirmLoading,
        disabled: !_ctx.isCanConfirm || _ctx.isDeclineLoading,
        onClick: _ctx.onConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_32,
          _createTextVNode(" Разрешить ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ])
  ]))
}